import {useNavigate} from 'react-router-dom';
import CardInputGroup from '../../../../components/mazraeKit/CardInputGroup';
import {CodeToInputGroupName} from '../../../../utilities/helper/codeToInputGroupName';
import {useGetInputGroupList} from '../../../../services/hookService';
import {InputNameToGroupName} from '../../../../pages/farm/advertisementList/utils';
import DotsLoading from '../../../../components/dotsLoading';
import {InputGroupCodes} from '../../../../utilities/inputGroupCodes';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
}
interface CategoryCardsProps<
  T extends {categories: Array<IFiltersKeyValuePairs>},
> {
  filters?: T;
  setFilters?: React.Dispatch<React.SetStateAction<T>>;
  chooseOneCard?: boolean;
}
const CategoryCards = <T extends {categories: Array<IFiltersKeyValuePairs>}>({
  filters,
  setFilters,
  chooseOneCard = false,
}: CategoryCardsProps<T>) => {
  const {inputGroupList, isLoading} = useGetInputGroupList();
  const navigate = useNavigate();

  const choosingHandler = (
    inputGroupItem: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    const found = filters?.categories?.some(
      el => el?.guid === inputGroupItem?.guid,
    );
    if (found) {
      setFilters &&
        setFilters(prev => {
          return {
            ...prev,
            categories: prev.categories.filter(
              item => item?.guid !== inputGroupItem?.guid,
            ),
          };
        });
    } else {
      setFilters &&
        setFilters(prev => {
          return {
            ...prev,
            categories: [
              ...prev.categories,
              {guid: inputGroupItem.guid, title: inputGroupItem.title},
            ],
          };
        });
    }
  };

  // Items groups which navigate to new page
  const itemGroups = [
    InputGroupCodes.FertilizerCode,
    InputGroupCodes.PesticideCode,
    InputGroupCodes.SeedsCode,
    InputGroupCodes.MachineryCode,
    InputGroupCodes.EquipmentCode,
  ];

  const clickHandler = (code: number) => {
    if (code === 18) {
      navigate('/lab-listing');
    } else if (itemGroups.includes(code)) {
      navigate(`/products/${CodeToInputGroupName[code]}`);
    } else {
      navigate(`/advertisement_listing/${CodeToInputGroupName[code]}`);
    }
  };

  if (isLoading) return <DotsLoading />;

  return (
    <div className="grid grid-cols-4 px-3 w-full">
      {inputGroupList
        ?.map(item => {
          return {...item, type: InputNameToGroupName[item.code]};
        })
        .map(item => {
          return (
            <div className="flex justify-center w-full" key={item.guid}>
              <CardInputGroup
                isActive={filters?.categories?.some(
                  el => el?.guid === item?.guid,
                )}
                isBoled={false}
                title={item.title}
                image={item.image}
                guid={item?.guid}
                clickHandler={() =>
                  !chooseOneCard
                    ? choosingHandler(item)
                    : clickHandler(item.code)
                }
              />
            </div>
          );
        })}
    </div>
  );
};

export default CategoryCards;
